import React from 'react'
import { Pencil } from 'lucide-react'
import { formatEditorialTitleForDisplay } from '../../lib/editorialTypography'

export interface LedgerRowTitlePresentation {
  primaryTitle?: string | null
  parallelTitle?: string | null
  titleOrigin?: string
  onEditTitle?: (rowId: string) => void
}

/** Row identity and operations belong above readings, never in a witness column. */
export function LedgerRowHeading({
  rowId, columnCount, controls, primaryTitle, parallelTitle, titleOrigin,
  onEditTitle, readOnly, rowLabel, ribbon,
}: LedgerRowTitlePresentation & {
  rowId: string
  columnCount: number
  controls: React.ReactNode
  ribbon?: React.ReactNode
  readOnly: boolean
  rowLabel: string
}) {
  return (
    <tr data-testid={`${primaryTitle ? 'ledger-row-title' : 'ledger-heading-row'}-${rowId}`} className="group/row-title bg-[#fffdfa]">
      <td colSpan={columnCount} className="border-b border-black/20 p-0">
        <div className="ledger-heading" title={primaryTitle ? `Title origin: ${titleOrigin || 'human'}` : undefined}>
          {controls}
          <div className="ledger-heading-content">
            {primaryTitle ? <div className="ledger-heading-title whitespace-normal">{formatEditorialTitleForDisplay(primaryTitle)}</div> : null}
            {parallelTitle ? <div dir="rtl" className="mt-0.5 whitespace-normal break-words text-right font-reader-arabic text-[13px] leading-5 text-gray-700">{parallelTitle}</div> : null}
          </div>
          {!readOnly && onEditTitle ? (
            <button type="button" onClick={() => onEditTitle(rowId)} aria-label={`Edit title for ${rowLabel}`} title="Edit row title"
              className="flex h-6 w-6 items-center justify-center border border-black bg-white text-black opacity-0 focus:opacity-100 group-hover/row-title:opacity-100">
              <Pencil className="h-3 w-3" aria-hidden="true" />
            </button>
          ) : null}
        </div>
        {ribbon}
      </td>
    </tr>
  )
}
